var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArticleSave = function SvgArticleSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.32.577a49.256 49.256 0 0 1 11.36 0c1.497.174 2.57 1.46 2.57 2.93V19a.75.75 0 0 1-1.085.67L9 16.089l-7.165 3.583A.75.75 0 0 1 .75 19V3.507c0-1.47 1.073-2.756 2.57-2.93Z",
    clipRule: "evenodd"
  })));
};
export default SvgArticleSave;